
<script>
import moment from 'moment'

export default {
  name: 'lk-tours',
  computed: {
    tours() {
      return this.$store.getters['lk/getTours']
    }
  },
  methods: {
    formatDate: date => moment.unix(date).format('DD.MM.YYYY'),
  }
}
</script>

<template>
  <div
    v-if="tours.length"
    class="lk__content-item lk__tours"
  >
    <div class="lk__content-item-header lk__content-item-header--green">
      <h2>Рекламные туры</h2>
    </div>
    <div class="lk__content-item-main">
      <div class="lk__tours-row">
        <div
          v-for="(tour, index) in tours"
          :key="index"
          class="lk__tours--item"
        >
          <h3 class="lk__tours-title">
            {{ tour.name }}
          </h3>
          <p class="lk__tours-date">
            {{ formatDate(tour.dateFrom) }}
            -
            {{ formatDate(tour.dateTo) }}
          </p>
          <p class="lk__tours-type">
            Город вылета: {{ tour.city }}
          </p>
          <p class="lk__tours--description">
            {{ tour.description }}
          </p>
          <div class="lk__tours-links">
            <p class="lk__tours-pay-type">
              {{ tour.price }}
            </p>
            <router-link
              :to="{ name: 'Sale' }"
              class="lk__tours--link rex-btn rex-btn--bold rex-btn--sm rex-btn--green"
            >
              <span>Регистрация</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="lk__content-item-footer">
      <router-link
        :to="{ name: 'Sale' }"
      >
        Рекламные туры
      </router-link>
    </div>
  </div>
</template>
